import { logger } from '@belong/logging';
import { IMobileDataProductsResponse, IMobileProductsResponse } from '@belong/types/api/products';
import { IMobileDataProductPlan, IMobileProductPlan, PlanAvailability, PRODUCT_FAMILY } from '@belong/types/product';
import { ProductAvailabilityFilter } from './types';

const AVAILABILITY_FILTER = {
  PUBLIC: [PlanAvailability.PUBLIC],
  ACTIVATE_SIM: [PlanAvailability.PUBLIC, PlanAvailability.SIM_RESTRICTED],
  CHANGE_PLAN: [PlanAvailability.PUBLIC, PlanAvailability.CONDITIONAL]
};

export const isMobileProductsResponse = (response?: object): response is IMobileProductsResponse => {
  return !!response && 'mobilePlans' in response;
};

export const isMobileDataProductsResponse = (response?: object): response is IMobileDataProductsResponse => {
  return !!response && 'mobileDataPlans' in response;
};

const ALLOWED_PRODUCTS = [PRODUCT_FAMILY.MOBILE_PLANS, PRODUCT_FAMILY.MOBILE_DATA_PLANS];
export const isValidProductFamily = (productFamily?: PRODUCT_FAMILY): boolean =>
  !!productFamily && ALLOWED_PRODUCTS.includes(productFamily);

export function filterPlansByAvailability<T extends IMobileProductPlan | IMobileDataProductPlan>(
  products: T[],
  filter: ProductAvailabilityFilter
): T[] {
  // Handle invalid filter
  if (!(filter in AVAILABILITY_FILTER)) {
    logger.error(`filterPlansByAvailability() - unknown filter '${filter}'`);
    return products;
  }

  const availabilities = AVAILABILITY_FILTER[filter];
  return products.filter(({ availability }) => availabilities.includes(availability));
}
